import { Component, h, tag } from "omi";
import confetti from "canvas-confetti";

import { Crown } from "@/wc/components/modals/modalTypes/paywallModal/crown.tsx";
import { animateCss } from "@/globals/styles";
import { NWButton } from "@/wc/components";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

import { ModalProps } from "../../models.ts";

export type WelcomeToProModalData = {};

type Props = ModalProps<WelcomeToProModalData>;

@tag("nw-welcome-to-pro-modal")
export class WelcomeToProModal extends Component<Props> {
  static css = [tailwind, animateCss];

  ready() {
    this.triggerConfetti();
  }

  private triggerConfetti() {
    confetti({
      particleCount: 1800,
      spread: 100,
      zIndex: 999,
      gravity: 0.4,
      angle: 45,
      startVelocity: 120,
      origin: {
        x: -0.2,
        y: 1.2,
      },
      drift: 1,
      ticks: 200,
    });

    confetti({
      particleCount: 1800,
      spread: 100,
      zIndex: 999,
      gravity: 0.4,
      angle: 135,
      startVelocity: 120,
      origin: {
        x: 1.2,
        y: 1.2,
      },
      drift: -1,
      ticks: 200,
    });
  }

  render({ close }: Props) {
    return (
      <div class="bg-white rounded-xl text max-w-lg w-full max-h-3/4 z-[100] rotate-2">
        <div class="content flex flex-col">
          <div class="body p-6">
            <div class="flex flex-col items-center">
              <div class="animate__animated animate__delay-3s animate__tada animate__slower">
                <Crown />
              </div>
            </div>
            <div class="rounded-2xl px-5 py-2">
              <h3 class="font-bold text-3xl">
                Welcome to NextWork <span class="text-leather">PRO</span>!
              </h3>
            </div>

            <div class="space-y-4 mt-3 text-secondary px-2">
              <p>
                <span class="font-signature text-3xl capitalize">
                  Hi {Store.user.getUsersName() || "fellow NextWorker"}!
                </span>
              </p>
              <p>WOW - Pro looks great on you! This feels like the start of something big.</p>
              <p>
                NextWork Pro is built for those who believe in always striving for more. It’s for learners like you who
                seek the best to become the best.
              </p>
              <p>Congratulations on starting the journey. You're looking more like a NextWork legend already.</p>
              <p class="">
                Love, <br />
                <span class="font-signature text-3xl capitalize">The NextWork team</span>
              </p>
            </div>
            <div class="pt-8">
              <NWButton type="primary" size="full" onClick={close}>
                Get started with Pro
              </NWButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
